// Format the value for the picker by converting UTC to local date
import { utcToLocal } from '@omnea-app/packages/universal/date-utils/utcToLocal'

export const formatDateForPicker = (date: Date | null) => {
  if (!date) return null
  return utcToLocal(date) // Convert UTC to local date for display
}
